import {SysAccount as Account} from './sys.account';
export class Common {


}
export class WebResponesContext {
    constructor() {
     this.ResponseMessage = new ResponseMessage();
     this.Other = new Other();
     this.Status = null;
    }
    /**
     * 当前用户信息
     */
         Account: Account;
       /**
         * 提示消息
         */
        ResponseMessage: ResponseMessage;
        /**
         * 返回结果集
         */
        Status: any;

        /**
         * 
         */
        url?:any;
        Other:Other;
         /**
     * 企业微信id
     */
    QYWXId?: string;
    /**
     * 企业类型
     */
    QYWXIdType?:string;
    /**
     * 企业微信code
     */
    QYWXQRCode?:string;
    }
      /**
   * 返回数据结果消息
   */
export class ResponseMessage {
    constructor() {
        this.Success = true;
        this.ErrorCode=0;
    }
    /**
   * 返回状态 数字类型
   */
  ErrorCode: number;
  /**
   * 错误消息内容
   */
  ErrorMessage: string;
  /**
   * 返回状态，boolean类型
   */
  Success: boolean;
}
export class Other{
  constructor(){
    this.Success =false;
    this.url="";

  }
  Success:boolean;
  url:any;

}
/**
 * 路由返回的参数结果集
 */
export class WebParameterActionRoute {
  /**
   * 相对于xml对应的ConfigName值
   */
  ConfigName: string;
  /**
   * ID值，string类型
   */
  id: string;
  /**
   * 操作类型，string类型
   */
  type: string;
  /**
   * 传递的其他参数，string类型
   */
  other: string;
}
/**
 * 前端请求参数实体类
 */
export class WebParameterContext {
    constructor() {
       this.ResponseMessage = new ResponseMessage();
       this.ParentConfig = new ParentConfiginfo();
       this.Account = new Account();
       this.Client = new Client();
    }
    Account:Account;
  /**
   * configName配置名称
   */
  ConfigName: string;
  /**
   * 请求参数，一些特殊特别不在Form或View中存在，或不与DB交互的参数
   */
  SpecialParameter: any;
  /**
   * 父级节点Config
   */
  ParentConfig: ParentConfiginfo;
  /**
   * 请求配置文件的类型，是Form还是View
   */
  ConfigType: string;
  /**
   * 操作类型
   */
  OpType: string;
  /**
   * 前端id传递
   */
  ID:string;
  /**
   * 当前页数
   */
  PageNumber: Number;
  /**
   * 请求参数
   */
  RequestBody: any;
  /**
   * 分页条数，如为0，表示不分页
   */
  RowsPerPage: Number;
  /**
   * 请求地址
   */
  url: string;
  ResponseMessage: ResponseMessage;
  /**
   * 当前页面对应的节点参数
   */
  Client: Client;

  /**
   * 当前组织
   */
    CurrentDepartment?: string;


    /**
     * 当前门店
     */
    StoreID?: string;
}
export class Client{
  constructor(){
    this.ClientType = 2;
    this.ApiType = "Element";
    this.Type = null;
  }
  /**
   * 当前请求的页面名称
   */
  PageName:string;
  /**
   * 当前请求的类型,默认 Element
   */
  ApiType:string;
  /**
   * 当前请求对应类型的Name
   */
  Name :string;
  /**
   * 当前返回的参数类型
   */
  Type: string;
  /**
   * 客户端类型，0表示android、1表示IOS、2表示Web
   */
  ClientType:number;
}
export class ParentConfiginfo {
    /**
     * 父级ConofigName
     */
    ConfigName: string;
    /**
     * 当前Element节点 Model属性
     */
    ActionModelName: string;
  }
    /**
   * 排序类型
   */
  export enum ConfigType {
        /// <summary>
        /// Form提交
        /// </summary>
        Form = 0,
        /// <summary>
        /// View提交
        /// </summary>
        View = 1,
        /// <summary>
        /// 按钮功能权限验证
        /// </summary>
        ButtonPermission = 2
    }
    /**
     * 操作类型
     */
  export enum OperationType {
        //
        // 摘要:
        //     插入数据
        ADD = 0,
        //
        // 摘要:
        //     虚拟删除，只是把表IsDelete值设置为1
        DELETE = 1,
        //
        // 摘要:
        //     更新数据
        EDITE = 2,
        //
        // 摘要:
        //     查询数据列表
        QUERY = 3,
        //
        // 摘要:
        //     获取数据单个实体
        GET = 4,
        //
        // 摘要:
        //     真实删除，从表中真实的删除数据
        REALDELETE = 5,
        /**
         * 查询数据列表，则不会根据sqlContext的内容进行转换成SQL对应的语句，SQL语句则会来源与SqlDynamicContext.FullSql_Or_CommandContentName，FullSql_Or_CommandContentName可以为DataCommand下配置的DataCommand.CommandContent.name，如果语句需要参数则需要通过SqlDynamicContext.QueryParameter提供，需要注意的是此情况下不提供分页功
         */
        QUERY_UnEscape = 6,
        //
        // 摘要:
        //     新增数据，不附加任何字段，提交什么字段插入数据库就是什么字段
        ADDOFPRIMITIVE = 7,
        //
        // 摘要:
        //     获取数据单个实体，用于用户编辑时的获取用户实体
        GETEDITE = 8
    }
    /**
     * 内容明细区域字段定制
     */
  export class viewData{
    /**
     * 菜单栏名称
     */
    head:string;
    /**
     * 标题
     */
    title:string;
    /**
     * 日期
     */
    date:any;
    /**
     * 作者
     */
    author:string;
    /**
     * 内容
     */
    content:string;
  }
    /**
   * App版本控制
   */
  export class AppInfo{
    /**
     * APP package 名称
     */
    Name:string;
    /**
     * android or ios
     */
    AndroidOrIos:boolean;
    /**
     * 版本号：0.0.0.0
     */
    AppVersion:string;
    /**
     * 是否推送版本
     */
    IsPush:boolean;
    /**
     * 是否强制更新
     */
    IsUpdate:boolean;
    /**
     * 提示语
     */
    Memo:string;
    /**
     * app package包 下载地址
     */
    Url:string;
    /**
     * IOS安装地址
     */
    webUrl:string;

  }